import { timeline } from '../state/timeline-state';

export const evalSpeed = (targetTime: number, seconds: number) => {
  const { currentTime } = timeline;
  return Math.abs(currentTime - targetTime) / seconds;
};
